// @ts-nocheck
import React, { useState, useEffect } from 'react';
import AccountBalance from './AccountBalance';
import useFetchPartner from './useFetchPartner';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { useTranslation } from '../i18n/LanguageContext';

const DashboardUser = () => {
  const { t } = useTranslation();
  const [currentHour, setCurrentHour] = useState(new Date().getHours());
  const jwtToken = sessionStorage.getItem('jwt');
  const data = useFetchPartner(jwtToken);
  const includedFeatures = [
    t('partnerDashboard.clients'),
    t('partnerDashboard.balance'),
    t('partnerDashboard.withdrawals'),
    t('partnerDashboard.transactions'),
  ];

  useEffect(() => {
    setCurrentHour(new Date().getHours());
  }, []);

  const getGreeting = () => {
    if (currentHour >= 0 && currentHour < 12) {
      return t('dashboard.morning');
    } else if (currentHour >= 12 && currentHour < 18) {
      return t('dashboard.afternoon');
    } else {
      return t('dashboard.evening');
    }
  };

  return (
    <main className="dashboard-shell">
      <div className="dashboard-layout">
        <AccountBalance />
        <section className="dashboard-welcome mt-8 p-6 sm:p-9 lg:p-10">
          <span className="dashboard-kicker">{t('partnerDashboard.subtitle')}</span>
          <h1 className="mt-5 text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
            {`${getGreeting()}, `}<span className="font-medium">{data.name}!</span>
          </h1>
          <h2 className="mt-8 text-xs font-extrabold uppercase tracking-[0.17em] text-green-cl">{t('dashboard.included')}</h2>
          <ul className="mt-4 grid gap-3 sm:grid-cols-2">
            {includedFeatures.map((feature) => (
              <li key={feature} className="dashboard-feature">
                <span className="dashboard-feature-icon"><CheckCircleIcon className="h-5 w-5" aria-hidden="true" /></span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </main>
  );
};

export default DashboardUser;
